import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";
import {AmplitudeViewItemListLocation} from "./track_amplitude_offer_view_item_list";

export interface ITrackAmplitudeSeeAllSelectItemParams {
    itemListName: AmplitudeItemListName;
    location: AmplitudeViewItemListLocation;
    itemName: string;
}

export const trackAmplitudeSeeAllSelectItem = (params: ITrackAmplitudeSeeAllSelectItemParams) => {
    const {itemListName, location, itemName} = params;

    trackAmplitudeEvent("select_item", {
        item_list_id: null,
        item_list_name: itemListName,
        location,
        item_category: "see_all_offers",
        item_id: null,
        property_id: null,
        item_name: itemName,
        index: null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";
import {AmplitudeViewItemListLocation} from "./track_amplitude_offer_view_item_list";

export interface ITrackAmplitudeSeeAllSelectItemParams {
    itemListName: AmplitudeItemListName;
    location: AmplitudeViewItemListLocation;
    itemName: string;
}

export const trackAmplitudeSeeAllSelectItem = (params: ITrackAmplitudeSeeAllSelectItemParams) => {
    const {itemListName, location, itemName} = params;

    trackAmplitudeEvent("select_item", {
        item_list_id: null,
        item_list_name: itemListName,
        location,
        item_category: "see_all_offers",
        item_id: null,
        property_id: null,
        item_name: itemName,
        index: null
    });
};
